import { useMemo } from "react";
import { useGlobalContactView } from "../../contactViews/global/GlobalContactViewProvider";
import { useLocalContactView } from "../../contactViews/local/LocalContactViewProvider";
import { ContactViewIndexResource } from "../types";

interface Values {
	currentContactView: ContactViewIndexResource | null;
	isLoading: boolean;
}
export const useContactView = (): Values => {
	const { localContactView } = useLocalContactView();
	const { globalContactView, isLoading } = useGlobalContactView();

	return useMemo(
		() => ({
			currentContactView: localContactView || globalContactView,
			isLoading,
		}),
		[globalContactView, isLoading, localContactView],
	);
};
